import { createFileRoute } from "@tanstack/react-router";

import { loaderHandler } from "src/lib/loaderHandler";
import { AdminAppFeaturesPage } from "src/pages/AdminAppFeaturesPage";
import { appFeaturesQueryOptions } from "src/queries/adminBilling";

export const Route = createFileRoute("/_auth/_admin/admin/billing/features")({
  component: AdminAppFeaturesPage,
  ssr: true,
  async loader({ context }) {
    return await loaderHandler(async () => {
      await context.queryClient.query({
        ...appFeaturesQueryOptions(),
        staleTime: "static",
      });

      return { data: {} };
    });
  },
});
